"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusTrap = useFocusTrap;
exports.default = void 0;

var _focusTrap = require("focus-trap");

var _react = require("react");

function useFocusTrap(focusTrapRef, trapFocus, options) {
  const focusTrapEl = focusTrapRef.current;
  (0, _react.useEffect)(() => {
    let focusTrap;

    if (trapFocus && focusTrapEl) {
      focusTrap = (0, _focusTrap.createFocusTrap)(focusTrapEl, { ...options
      });
      focusTrap.activate();
    }

    return () => {
      if (focusTrap) {
        focusTrap.deactivate();
      }
    };
  });
}

var _default = useFocusTrap;
exports.default = _default;
//# sourceMappingURL=useFocusTrap.js.map